import React, {useEffect} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import CountersCard from '../../../../ui/CountersCard';
import Breadcrumbs from "../../../../ui/Breadcrumbs";
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import Grid from '@material-ui/core/Grid';

import {
  counterProgramsQuery,
  counterModulesQuery,
  counterExpertiseQuery,
  counterMasterClassQuery
} from "./reducer"

const items = [
  {
    label: "Управление ООП",
    link: "#"
  },
  {
    label: "Ресурсы",
    link: "/work/app/manage/resources"
  },
  {
    label: "Образовательные программы и модули",
    link: "#"
  },
];

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
  },
});

const ManageOOPResourcesOPModIndex = ({
                                        history,
                                        counterPrograms,
                                        counterModules,
                                        counterExpertise,
  counterMasterClasses,
                                        counterMasterClassQuery,
                                        counterProgramsQuery,
                                        counterModulesQuery,
                                        counterExpertiseQuery
                                      }) => {

  const classes = useStyles();

  const handleClick = (link) => {
    history.push(link);
  };

  useEffect(() => {
    counterProgramsQuery();
  }, [counterProgramsQuery]);

  useEffect(() => {
    counterModulesQuery();
  }, [counterModulesQuery]);

  useEffect(() => {
    counterMasterClassQuery();
  }, [counterMasterClassQuery]);

  useEffect(() => {
    counterExpertiseQuery();
  }, [counterExpertiseQuery]);


  return (
    <div>
      <Breadcrumbs items={items}/>
      <div className={classes.root}>
        <Grid container spacing={0} justify="flex-start" alignItems="flex-start">
          {counterPrograms && <Grid item xs={12} sm={6} md={4} lg={3}>
            <CountersCard
              data={counterPrograms}
              onClick={handleClick}
              goTo={'/work/app/manage/resources/programs/my-programs'}
            />
          </Grid>}
          {counterModules && <Grid item xs={12} sm={6} md={4} lg={3}>
            <CountersCard
              data={counterModules}
              onClick={handleClick}
              goTo={'/work/app/manage/resources/programs/my-modules'}
            />
          </Grid>}
          {counterMasterClasses && <Grid item xs={12} sm={6} md={4} lg={3}>
            <CountersCard
              data={counterMasterClasses}
              onClick={handleClick}
              goTo={'/work/app/manage/resources/programs/my-master-classes'}
            />
          </Grid>}
          {counterExpertise && <Grid item xs={12} sm={6} md={4} lg={3}>
            <CountersCard
              data={counterExpertise}
              onClick={handleClick}
              goTo={'/work/app/manage/resources/programs/expertise'}
            />
          </Grid>}
        </Grid>
      </div>
    </div>
  )
};

const mapStateToProps = state => ({
  counterPrograms: state.manageOOPResourcesOpModIndex.counterPrograms,
  counterModules: state.manageOOPResourcesOpModIndex.counterModules,
  counterExpertise: state.manageOOPResourcesOpModIndex.counterExpertise,
  counterMasterClasses: state.manageOOPResourcesOpModIndex.counterMasterClasses,
});

const mapDispatchToProps = dispatch => ({
  counterProgramsQuery: () => dispatch(counterProgramsQuery()),
  counterModulesQuery: () => dispatch(counterModulesQuery()),
  counterExpertiseQuery: () => dispatch(counterExpertiseQuery()),
  counterMasterClassQuery: () => dispatch(counterMasterClassQuery()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ManageOOPResourcesOPModIndex));
